import * as React from "react";
import { Input, IconButton } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import AttachIcon from "@material-ui/icons/AttachFile";

import FileUpload from "./fileUpload";
import { File } from "src/api/classes";

interface Props {
  canAttachFile?: boolean;
  placeholder?: string;
  onSend: (text: string, files?: File[], callback?: () => void) => void;
}
interface State {
  text: string;
  showAttach: boolean;
  files: File[];
}
export default class SendMessageArea extends React.Component<Props, State> {
  state = {
    text: "",
    showAttach: false,
    files: []
  };
  send = () => {
    this.props.onSend(
      this.state.text,
      this.props.canAttachFile ? this.state.files : undefined,
      () => {
        this.setState({ text: "", files: [] });
      }
    );
  };
  render() {
    return (
      <div
        style={{
          backgroundColor: "#F4F1EE",
          borderRadius: 8
        }}
      >
        <div
          style={{
            display: "flex",
            padding: 12,
            borderRadius: 8
          }}
        >
          {this.props.canAttachFile && (
            <IconButton
              onClick={() => {
                this.setState({ showAttach: !this.state.showAttach });
              }}
            >
              <AttachIcon />
            </IconButton>
          )}
          <Input
            style={{
              backgroundColor: "white",
              borderRadius: 24,
              marginRight: 12,
              marginTop: 4,
              marginBottom: 4,
              paddingLeft: 12,
              paddingTop: 12,
              flex: 1
            }}
            multiline
            value={this.state.text}
            onChange={e => this.setState({ text: e.target.value })}
            inputProps={{
              flex: 1
              // verticalTextAlign: "center"
            }}
            disableUnderline
            placeholder={this.props.placeholder || "Type Your Message"}
          />
          <IconButton onClick={this.send}>
            <SendIcon />
          </IconButton>
        </div>
        {this.state.files.length > 0 && (
          <div style={{ marginLeft: 64, paddingBottom: 12 }}>
            {this.state.files.map(file => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8
                  }}
                >
                  <a
                    target="_blank"
                    href={
                      "https://dubito.s3.eu-central-1.amazonaws.com/" +
                      file.file_url
                    }
                  >
                    {file.file_url.lastIndexOf("/") > -1
                      ? file.file_url.substring(
                          file.file_url.lastIndexOf("/") + 1
                        )
                      : file.file_url}
                  </a>
                </div>
              );
            })}
          </div>
        )}
        {this.state.showAttach && (
          <div style={{ paddingBottom: 12 }}>
            <FileUpload
              onUploaded={file => {
                const list = this.state.files;
                list.push(file);
                this.setState({ files: list, showAttach: false });
              }}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sendMessageArea.tsx